// Imports
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetCommitteesResponse } from '../../../../../../shareables/types/api/main/website/page/type/209/committees/get';
import Table from '../shared-components/table';
import CommitteeMembersRow from './row';


// Styled components
const Committee = styled.div`
	h3 {
		font-size: 1.5rem;
		font-weight: 500;
		line-height: 1.1;
	}
	
	margin-top: 0.0938rem;
	padding: 0.9375rem;
	margin-bottom: 1.25rem;
	
	background-color: #fff;
	border: 0.0625rem solid #ddd;
	border-radius: 0.25rem;
	box-shadow: 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.05);
`;

const Purpose = styled.div`
	margin-top: 0.625rem;
	font-size: 1rem;
	line-height: 1.3125rem;
	
	white-space: pre-line;
`;

const Wrapper = styled.div`
	margin-top: 1.5625rem;
`;

const NoneAdded = styled.div`
	margin-top: -0.0938rem;
`;


// Define the accepted props
interface Props {
	pageID: number;
	storybookCommittees?: GetCommitteesResponse;
}


// Function component
const Committees: React.FC<Props> = ({ pageID, storybookCommittees }) => {
	// Use state
	const [committees, setCommittees] = useState<GetCommitteesResponse | null>(storybookCommittees ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load committees on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetCommitteesResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/page/id_${pageID}/type/209/committees`,
				completion: (json) => {
					setCommittees(json.response);
				},
			})
		);
	}, [dispatch, pageID]);
	
	
	// If loading, then display nothing
	if (committees === null) {
		return null;
	}
	
	
	// Return JSX
	return (
		<React.Fragment>
			{committees.length > 0 ? (
				committees.map((committee) => (
					<Committee key={committee.id}>
						<h3>{committee.name}</h3>
						
						{committee.purpose && <Purpose>{committee.purpose}</Purpose>}
						
						{committee.members.length > 0 && (
							<Wrapper>
								<Table>
									<thead>
										<tr>
											<th>Committee member</th>
											<th>Contact info</th>
										</tr>
									</thead>
									
									<tbody>
										{committee.members?.map((member) => (
											<CommitteeMembersRow key={member.id} committeeMember={member}></CommitteeMembersRow>
										))}
									</tbody>
								</Table>
							</Wrapper>
						)}
					</Committee>
				))
			) : (
				<NoneAdded>
					<em>No committees have been added yet…</em>
				</NoneAdded>
			)}
		</React.Fragment>
	);
};

export default Committees;
